//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import work_bench_item from "@/components/work_bench_item";
import "@/assets/css/reset.css";
import "@/assets/css/global.css";

export default {
  components: { work_bench_item },
  data() {
    return {
      indexData: {},
      actionTitle: "",
      actionList: [],
      showActionSheet: false,
      actionSheet1: {
        title: "门店采购入库",
        actions: [
          {
            name: "1.门店采购入库单",
            url: this.$api.host + "/Sms/ShopStockInBuyOrder"
          },
          {
            name: "2.门店采购入库明细",
            url: this.$api.host + "/Sms/ShopStockInBuyOrder/DetailIndex"
          }
        ]
      },
      actionSheet2: {
        title: "门店退货出库",
        actions: [
          {
            name: "1.门店退货出库单",
            url: this.$api.host + "/mSms/ShopStockOutReturnOrder"
          },
          {
            name: "2.门店退货出库明细",
            url: this.$api.host + "/mSms/ShopStockOutReturnOrder/DetailIndex"
          }
        ]
      },
      work_bench_item1: [
        {
          img: "images/20_03.png",
          text: "会员列表",
          link: this.$api.host + "/mCM/Member/Index"
        },
        {
          img: "images/3_10.png",
          text: "活动列表",
          link: this.$api.host + "/mCM/NewCustomerActivity/Index",
          hide_border: true
        }
      ],
      work_bench_item2: [
        {
          img: "images/20_07.png",
          text: "会员参与情况",
          link: this.$api.host + "/mCM/PrizeStockOutJoinOrder/Index"
        },
        {
          img: "images/20_11.png",
          text: "优惠券核销记录",
          link: this.$api.host + "/mCM/MemberCouponOrder/Index",
          hide_border: true
        }
      ]
    };
  },
  computed: {},

  async onLoad() {},

  created() {},

  methods: {
    saleCheckinOrder() {
      this.showActionSheet = true;
      this.actionTitle = this.actionSheet1.title;
      this.actionList = this.actionSheet1.actions;
    },
    saleReturnCheckoutOrder() {
      this.showActionSheet = true;
      this.actionTitle = this.actionSheet2.title;
      this.actionList = this.actionSheet2.actions;
    },
    onSelect(item) {
      console.log(item);
      if (item.url) {
        if (item.url.indexOf("http") == -1) {
          this.$router.push(item.url);
        } else {
          window.location = item.url;
          this.$toast({
            type: "loading",
            duration: 0, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: "spinner",
            message: "加载中"
          });
        }
      }
    }
  }
};
